import { NewReaction } from '@/types/models';

export default function getModelElementsElementIdsFromReaction(
  reaction: NewReaction,
): Array<number> {
  const elementsIds: Array<number> = [];
  [...reaction.products, ...reaction.reactants, ...reaction.modifiers].forEach(element => {
    if (element.element) {
      elementsIds.push(element.element);
    }
  });
  return elementsIds;
}
